<template>
  <div class="stat-item-card-container">
    <div>
      <span class="stat-item-card-value">{{ value }}</span>
    </div>
    <div class="space-between">
      <h3 class="section-heading">{{ label }}</h3>
      <div class="c__info" v-if="tooltip">
        <div class="c__tooltip_container">
          <icon-info></icon-info>
          <div
            class="c__tooltip custom-tooltip"
            style="max-width: 280px; white-space: normal; word-wrap: break-word;"
          >
            <p style="margin-bottom: 0px;">{{ tooltip }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconInfo from '../../assets/icons/icon-info';
export default {
  props: ['value', 'label', 'tooltip'],
  components: {
    IconInfo,
  },
};
</script>

<style scoped>
.stat-item-card-container {
  background-color: #fff;
  border-radius: 0.5rem;
  -webkit-box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  padding: 1rem;
}
.stat-item-card-value {
  color: #13a3eb;
  font-family: Proxima nova, proxima-nova, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 38px;
}

.c__info {
  text-align: right;
}

.c__info .c__tooltip_container {
  cursor: pointer;
  position: relative;
  display: inline-block;
}
.custom-tooltip {
  width: 280px !important;
  max-width: 280px !important;
  min-width: 280px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  text-align: center !important;
  box-sizing: border-box !important;
  hyphens: none !important;
}
</style>
